import { api } from "@/shared/libs/axiosClient";

export interface Team {
  id: number;
  name: string;
  slack_channel_id: string | null;
  created_at: string | null;
}

export interface TeamUpdate {
  name?: string;
  slack_channel_id?: string | null;
}

export async function fetchTeams(): Promise<Team[]> {
  return api.get<Team[]>("/team");
}

export async function fetchMyTeams(): Promise<Team[]> {
  return api.get<Team[]>("/team/me");
}

export async function getTeam(teamId: number): Promise<Team> {
  return api.get<Team>(`/team/${teamId}`);
}

export async function updateTeam(teamId: number, data: TeamUpdate): Promise<Team> {
  return api.patch<Team>(`/team/${teamId}`, data);
}

export async function createTeam(name: string): Promise<Team> {
  return api.post<Team>("/team", { name });
}

export async function deleteTeam(
  teamId: number,
): Promise<{ deleted: boolean; team_id: number }> {
  return api.delete<{ deleted: boolean; team_id: number }>(`/team/${teamId}`);
}
